import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Controller, FieldError, useForm, useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { FilterMatchMode } from 'primereact/api';
import * as myconst from "../../../constants/index"
import { Tooltip } from 'primereact/tooltip';
import { spawn } from 'child_process';
import ParamsPopUp from '../Params-Info-popup';
import { Message } from 'primereact/message';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { deleteDark, infoIcon, plusIconSimple } from 'assets/icons';


const FrontEnd = ({ methods,
    clientVersion,
    questions,
    setQuestions,
    inputFile1,
    inputFile2,
    setInputFile1,
    setInputFile2,
    fieldData,
    fileChange,
    setInputFile1Base,
    setInputFile2Base,
    inputFile1Base,
    inputFile2Base,
}: any) => {
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [modalContent, setModalContent] = useState('');

    const {
        // formState: { errors },
        reset
    } = useForm()

    // const {register} = methods
    const formFields = myconst.formFields;

    const { register, setValue, formState: { errors }, getValues } = useFormContext()

    const addQuestion = () => {
        if (questions.length < 3) {
            setQuestions([...questions, '']);
        }
    };

    const removeQuestion = (indexToRemove: number) => {
        const updatedQuestions = questions.filter((_: any, index: any) => index !== indexToRemove);
        setQuestions(updatedQuestions);
    };


    const setValues = (fieldData?: any) => {
        Object.keys(fieldData)?.forEach((key: any) => {
            const value = fieldData[key];

            // Skip setting values for fields containing "logo" in their names
            if (!key.toLowerCase().includes('logo')) {
                if (typeof value === 'object' && value !== null) {
                    Object.keys(value).forEach((nestedKey) => {
                        const nestedValue = value[nestedKey];
                        setValue(`${key}.${nestedKey}`, nestedValue);
                    });
                } else {
                    setValue(key, value);
                }
            }
        });
    };


    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: '', matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue('');
    };

    const onChangeFunction = (e: any, rowData: any) => {
        if (rowData.field === 'logos_urls.logo_home_page') {
            fileChange(e.target.files[0], 'logo_home_page');
            setInputFile1(e?.target.value)
        } else if (rowData.field === 'logos_urls.logo_side_img') {
            fileChange(e.target.files[0], 'logo_side_img');
            setInputFile2(e?.target.value)
        }
    };


    const convertBase64ToImage = (base64Str: any) => {
        const byteCharacters = atob(base64Str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const imageBlob = new Blob([byteArray], { type: 'image/jpeg' });
        const imageUrl = URL.createObjectURL(imageBlob);
        return imageUrl;
    };


    // useEffect(() => {
    //     setValues(fieldData)
    // }, [fieldData])


    useEffect(() => {
        initFilters()
    }, [])


    const logo1 = `data:image/png+xml;base64,${inputFile1Base}`
    const logo2 = `data:image/png+xml;base64,${inputFile2Base}`

    const renderInput = (rowData: any) => {
        switch (rowData.field) {
            case 'logos_urls.logo_home_page':
                return (
                    <div className="d-flex align-items-center">
                        {inputFile1Base ? (
                            <>
                                <div className="param-image-container">
                                    <img src={logo1} alt='image-logo' className='param-image' />
                                </div>
                                <div className="custom-file-input">
                                    <label htmlFor="fileInput" className={clientVersion !== "" ? "disabled-label" : ""}>Choose File</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e: any) => {
                                            onChangeFunction(e, rowData);
                                        }}
                                        disabled={clientVersion !== "" ? true : false}
                                        accept="image/png,image/jpg, image/jpeg" />
                                </div>
                                {/* <p className='mb-0 ml-3'>{inputFile1 ? inputFile1 : "No file chosen"}</p> */}
                            </>) : (
                            <>
                                <div className="custom-file-input">
                                    <label htmlFor="fileInput" className={clientVersion !== "" ? "disabled-label" : ""}>Choose File</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e: any) => {
                                            onChangeFunction(e, rowData);
                                        }}
                                        disabled={clientVersion !== "" ? true : false}
                                        accept="image/png, image/gif, image/jpeg" />
                                </div>
                                {/* <p className='mb-0 ml-3'>{inputFile1 ? inputFile1 : "No file chosen"}</p> */}
                            </>
                        )
                        }
                    </div >
                );
            case 'logos_urls.logo_side_img':
                return (
                    <div className="d-flex align-items-center">
                        {inputFile2Base ? (
                            <>
                                <div className="param-image-container">
                                    <img src={logo2} alt='image-logo' className='param-image' />
                                </div>
                                <div className="custom-file-input">
                                    <label htmlFor="fileInput2" className={clientVersion !== "" ? "disabled-label" : ""}>Choose File</label>
                                    <input
                                        type="file"
                                        id="fileInput2"
                                        onChange={(e: any) => {
                                            onChangeFunction(e, rowData);
                                        }}
                                        disabled={clientVersion !== "" ? true : false}
                                        accept="image/png, image/gif, image/jpeg" />
                                </div>
                                {/* <p className='mb-0 ml-3' >{inputFile2 ? inputFile2 : "No file chosen"}</p> */}
                            </>) : (
                            <>
                                <div className="custom-file-input">
                                    <label htmlFor="fileInput2" className={clientVersion !== "" ? "disabled-label" : ""}>Choose File</label>
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        id="fileInput2"
                                        onChange={(e: any) => {
                                            onChangeFunction(e, rowData);
                                        }}
                                        disabled={clientVersion !== "" ? true : false}
                                        accept="image/png, image/gif, image/jpeg" />
                                </div>
                                {/* <p className='mb-0 ml-3'>{inputFile2 ? inputFile2 : "No file chosen"}</p> */}
                            </>
                        )
                        }
                    </div>
                );
            case 'client_name':
                return <>
                    <Controller
                        name={rowData.field}
                        control={methods.control}
                        rules={{ required: `${rowData.header} is Required` }}
                        render={({ field }) => (
                            <>
                                <div className='param-tab-form'>
                                    <div className='form-row'>
                                        <div className='form-col'>
                                            <InputText
                                                // {...register(`${rowData.field}`, {
                                                //     required: {
                                                //         value: true,
                                                //         message: `${rowData.header} is Required`
                                                //     }
                                                // })}
                                                {...field}
                                                className='w-full' disabled={true} /><p style={{ color: "#FF5155" }}>
                                                {errors[`${rowData.field}`]?.message?.toString()} {/* Convert to string */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    />
                </>
            case 'default_label':
                return (
                    <>
                        <Controller
                            name={rowData.field}
                            control={methods.control}
                            rules={{ required: `${rowData.header} is Required` }}
                            render={({ field }) => (
                                <>
                                    <div className='param-tab-form'>
                                        <div className='form-row'>
                                            <div className='form-col'>
                                                <InputTextarea
                                                    // {...register(`${rowData.field}`, {
                                                    //     required: {
                                                    //         value: true,
                                                    //         message: `${rowData.header} is Required`
                                                    //     }
                                                    // })}
                                                    {...field}
                                                    disabled={clientVersion !== "" ? true : false}
                                                    rows={5}
                                                    cols={30}
                                                    className='w-full' /><p style={{ color: "#FF5155" }}>
                                                    {errors[`${rowData.field}`]?.message?.toString()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        />
                    </>
                );

            case 'default_questions':
                return (
                    <div>
                        {questions.map((question: any, index: any) => (
                            <>
                                {questions.length !== 0 ?
                                    <>
                                        <div key={index} className="mb-3 d-flex align-items-center param-tab-form">
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <InputText
                                                        type="text"
                                                        placeholder={`Enter Question ${index + 1}`}
                                                        value={question}
                                                        {...register(`${rowData.field}.${index}`, {
                                                            required: {
                                                                value: index === 0,
                                                                message: index === 0 ? `Question is required` : ''
                                                            }
                                                        })}
                                                        disabled={clientVersion !== "" ? true : false}
                                                        onChange={(e) => {
                                                            const updatedQuestions = [...questions];
                                                            updatedQuestions[index] = e.target.value;
                                                            setQuestions(updatedQuestions);
                                                        }}
                                                    />
                                                    {index === 0 && (
                                                        <i
                                                            className="ml-3"
                                                            style={{ cursor: questions.length < 3 && clientVersion === "" ? "pointer" : "default" }}
                                                            onClick={() => { clientVersion === "" && addQuestion() }}
                                                        >
                                                            <img src={plusIconSimple} alt='plus-icon' />
                                                        </i>
                                                    )}
                                                    {index !== 0 && (
                                                        <i className="ml-3"
                                                            style={{ cursor: clientVersion === "" ? "pointer" : "default" }}
                                                            onClick={() => { clientVersion === "" && removeQuestion(index) }}
                                                        >
                                                            <img src={deleteDark} alt='delete-icon' />
                                                        </i>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {index === 0 && (errors as any)?.default_questions && (errors as any)?.default_questions[0]?.message && (
                                            <p style={{ color: "#FF5155" }}>
                                                {(errors as any)?.default_questions[0]?.message}
                                            </p>
                                        )}
                                    </>
                                    :
                                    <>
                                        <div className="mb-3 d-flex align-items-center param-tab-form">
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <InputText
                                                        disabled={clientVersion !== "" ? true : false}
                                                        type="text"
                                                        placeholder="Enter Question 1"
                                                        {...register(`${rowData.field}.0`, {
                                                            // required: {
                                                            //     value: true,
                                                            //     message: `${rowData.header} is required`
                                                            // }
                                                        })}
                                                        className='form-control p-inputtext-lg'
                                                        onChange={(e) => {
                                                            const updatedQuestions = [...questions];
                                                            updatedQuestions[0] = e.target.value;
                                                            setQuestions(updatedQuestions);
                                                        }}
                                                    />
                                                </div>
                                                <i className="ml-2" onClick={() => { clientVersion === "" && addQuestion() }}>
                                                    <img src={plusIconSimple} alt='plus-icon' />
                                                </i>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        ))}
                        {/* {questions.length === 0 && (
                           
                        )} */}
                    </div>
                )
        }
    };

    return (
        <>
            <div className="datatable-wrapper">
                <div className="w-full mb-3">
                    <IconField iconPosition="right" className='user-input'>
                        <InputIcon className="pi pi-search"></InputIcon>
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            autoComplete='off'
                            onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            placeholder='Search by parameter'
                            className='search-bar-input w-full' />
                    </IconField>
                </div>
                <DataTable
                    filters={filters}
                    globalFilterFields={["header"]}
                    showGridlines
                    value={formFields}
                    emptyMessage="No fields found."
                    scrollable
                    scrollHeight='440px'
                >
                    <Column
                        header="Category"
                        field='category'
                        style={{ minWidth: '100px' }}
                    />
                    <Column
                        header="Parameter"
                        field='header'
                        filterField='header'
                        sortable
                        style={{ minWidth: '300px' }}
                        body={(rowData: any, options: { rowIndex: number }) => {
                            const targetId = `tooltip-${options.rowIndex}`;
                            return (
                                <>
                                    <span className="header-tooltip">
                                        <span className={`tooltip-target-${options.rowIndex}`}>
                                            {rowData.header}
                                            <span className="mr-2" style={{ color: "#FF5155" }}>*</span>
                                            <i data-bs-toggle="modal"
                                                data-bs-target="#Params-Info"
                                                onClick={() => setModalContent(rowData.toolTipInfo)}
                                                style={{ cursor: "pointer", lineHeight: 0 }}
                                            >
                                                <img src={infoIcon} alt='info-icon' />
                                            </i>
                                            {/* <Tooltip target={`#${targetId}`} content={rowData.header} position="top" /> */}
                                        </span>
                                    </span>
                                </>
                            );
                        }}
                    />
                    {/* <Column
                    header="Description"
                    style={{ minWidth: '' }}
                    body={(rowData: any, options: { rowIndex: number }) => {
                        return (
                            <><span className="header-tooltip">
                                <span className={`tooltip-target-${options.rowIndex}`}>
                                    <i
                                        data-bs-toggle="modal"
                                        data-bs-target="#Params-Info"
                                        // id={targetId}
                                        className="pi pi-info-circle header-tooltip-icon ml-2"
                                        onClick={() => setModalContent(rowData.toolTipInfo)}
                                    ></i>
                                </span>
                            </span>
                                <div>
                                    <ParamsPopUp content={modalContent} />
                                </div>
                            </>
                        );
                    }}
                /> */}
                    <Column
                        header="Field 1"
                        field='field1'
                        style={{ minWidth: '150px' }}
                    />
                    <Column
                        header="Field 2"
                        field='field2'
                        style={{ minWidth: '150px' }}
                    />
                    <Column
                        header="Value"
                        style={{ minWidth: '600px' }}
                        showFilterMenu={false}
                        body={(rowData: any) => (
                            <div>
                                {renderInput(rowData)}
                            </div>
                        )}
                    />
                </DataTable>
            </div>
            <ParamsPopUp content={modalContent} />
        </>
    );
};

export default FrontEnd;
